require('./runtime');
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("./button"), require("./draglayer"), require("./flexlayout"), require("./hspacer"), require("./itemdnd"), require("./list"), require("./utils"));
	else if(typeof define === 'function' && define.amd)
		define(["./button", "./draglayer", "./flexlayout", "./hspacer", "./itemdnd", "./list", "./utils"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("./button"), require("./draglayer"), require("./flexlayout"), require("./hspacer"), require("./itemdnd"), require("./list"), require("./utils")) : factory(root["./button"], root["./draglayer"], root["./flexlayout"], root["./hspacer"], root["./itemdnd"], root["./list"], root["./utils"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(globalThis, (__WEBPACK_EXTERNAL_MODULE__32477__, __WEBPACK_EXTERNAL_MODULE__84803__, __WEBPACK_EXTERNAL_MODULE__77765__, __WEBPACK_EXTERNAL_MODULE__39636__, __WEBPACK_EXTERNAL_MODULE__40772__, __WEBPACK_EXTERNAL_MODULE__70309__, __WEBPACK_EXTERNAL_MODULE__78815__) => {
return (globalThis["wpBaUiCarbonToolkit"] = globalThis["wpBaUiCarbonToolkit"] || []).push([[3876],{

/***/ 63815:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var _interopRequireDefault = __webpack_require__(97880);
exports.__esModule = true;
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(__webpack_require__(38213));
var _defineProperty2 = _interopRequireDefault(__webpack_require__(68779));
var _react = _interopRequireWildcard(__webpack_require__(16689));
var _propTypes = _interopRequireDefault(__webpack_require__(580));
var _list = _interopRequireWildcard(__webpack_require__(70309));
var _utils = __webpack_require__(78815);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019, 2021
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */

const {
  sortBy,
  forOwn,
  findIndex
} = _utils.lodash;
const {
  multiSelect,
  singleSelect
} = _utils.listHelper;
const {
  sanitize,
  getInheritedProps
} = _utils.propsUtils;
function purge(byIdData, byIdMap) {
  forOwn(byIdData, (v, key) => {
    if (!byIdMap[key]) {
      delete byIdData[key];
    }
  });
}
function toBoolMap(byIdObjects) {
  return Object.keys(byIdObjects).reduce((map, id) => {
    map[id] = !!byIdObjects[id];
    return map;
  }, {});
}
function computePathToRoot(node) {
  let result = '';
  let p = node;
  do {
    result = result ? `${p.relativeIndex}_${result}` : `${p.relativeIndex}`;
    p = p.parent;
  } while (p);
  return result;
}
class Tree extends _react.Component {
  constructor() {
    var _this;
    super(...arguments);
    _this = this;
    (0, _defineProperty2.default)(this, "state", {
      filterCollapsedNodes: {},
      active: this.props.activeNode ? this.props.getId(this.props.activeNode) : null
    });
    (0, _defineProperty2.default)(this, "getOrderedSelectedNodes", function (selectedNodes) {
      if (selectedNodes === void 0) {
        selectedNodes = _this.state.selectedNodes;
      }
      const selectedMap = _this._toObjectMap(selectedNodes);
      return sortBy(Object.keys(selectedMap), id => _this._byIdMap[id].index).map(id => selectedMap[id]);
    });
    (0, _defineProperty2.default)(this, "getSelectedNodes", () => {
      const selectedMap = this._toObjectMap(this.state.selectedNodes);
      return Object.keys(selectedMap).map(id => selectedMap[id]);
    });
    (0, _defineProperty2.default)(this, "_activeIndex", -1);
    (0, _defineProperty2.default)(this, "_pivotIndex", -1);
    (0, _defineProperty2.default)(this, "_lastClickIndex", -1);
    (0, _defineProperty2.default)(this, "_byIdMap", {});
    (0, _defineProperty2.default)(this, "_data", []);
    (0, _defineProperty2.default)(this, "_prevExpandedNodes", {});
    (0, _defineProperty2.default)(this, "_flattenTree", true);
    (0, _defineProperty2.default)(this, "_getParentIndex", index => {
      const id = this._getId(index);
      const {
        parent
      } = this._byIdMap[id];
      if (!parent) {
        return -1;
      }
      return this._data.indexOf(parent);
    });
    (0, _defineProperty2.default)(this, "_isExpandedByIndex", index => {
      const {
        filter
      } = this.props;
      const {
        filterCollapsedNodes
      } = this.state;
      const id = this._getId(index);
      return filter ? !filterCollapsedNodes[id] : this._isExpandedById(id);
    });
    (0, _defineProperty2.default)(this, "_isExpandedById", id => {
      const {
        expandedByDefault
      } = this.props;
      const {
        expandedNodes
      } = this.state;
      return expandedByDefault ? !Object.prototype.hasOwnProperty.call(expandedNodes, id) || expandedNodes[id] : expandedNodes[id];
    });
    (0, _defineProperty2.default)(this, "_isSelected", index => this.state.selectedNodes[this._getId(index)]);
    (0, _defineProperty2.default)(this, "_itemRenderer", (index, props) => {
      const treeNode = this._data[index];
      const {
        focusDepth,
        hasChildren,
        alwaysExpanded,
        visible,
        node
      } = treeNode;
      const expanded = this._isExpandedByIndex(index);
      const {
        itemRenderer,
        data,
        focusNode,
        filter
      } = this.props;
      const treeProps = {
        ...props,
        node,
        hasChildren,
        alwaysExpanded,
        depth: focusDepth,
        expanded,
        visible,
        data,
        pathToRoot: computePathToRoot(treeNode),
        isFocusNode: !filter && focusNode && focusNode === node
      };
      return itemRenderer(node, treeProps);
    });
    (0, _defineProperty2.default)(this, "_onActiveChange", event => {
      this.setState(() => {
        const {
          index,
          type
        } = event;
        const {
          onActiveChange
        } = this.props;
        let newState;
        if (type === _list.activeEventTypes.ABSOLUTE) {
          const active = this._getId(index);
          newState = {
            active
          };
        } else {
          const delta = type === _list.activeEventTypes.UP ? -1 : 1;
          const active = this._getId(this._activeIndex + delta);
          newState = {
            active
          };
        }
        onActiveChange && onActiveChange(newState.active ? this._byIdMap[newState.active].node : null);
        return newState;
      });
    });
    (0, _defineProperty2.default)(this, "_onMenu", (x, y, e) => this.props.onMenu(x, y, this._toObjectMap(this.state.selectedNodes), e));
    (0, _defineProperty2.default)(this, "_onExpand", event => {
      const {
        index,
        type
      } = event;
      const {
        onExpand,
        data,
        filter
      } = this.props;
      const treeNode = this._data[index];
      const activeNode = this._byIdMap[this.state.active];
      const {
        id
      } = treeNode;
      let expanded;
      if (type === _list.expandEventTypes.TOGGLE) {
        expanded = !this.state.expandedNodes[id];
      } else if (type === _list.expandEventTypes.EXPAND) {
        expanded = true;
      } else if (type === _list.expandEventTypes.COLLAPSE) {
        expanded = false;
      }
      if (!expanded && activeNode) {
        let inHierarchy = false;
        let node = activeNode;
        while (node && !inHierarchy) {
          inHierarchy = node.parent === treeNode;
          node = node.parent;
        }
        if (inHierarchy) {
          this.setState({
            active: id,
            pivot: id,
            lastClick: id
          });
        }
      }
      const expandedNodes = {
        ...this.state.expandedNodes,
        [id]: expanded
      };
      const filterCollapsedNodes = {
        ...this.state.filterCollapsedNodes,
        [id]: !expanded
      };
      if (!this.props.expandedNodes) {
        this.setState({
          expandedNodes,
          filterCollapsedNodes
        });
      } else if (filter) {
        this.setState({
          filterCollapsedNodes
        });
      }
      onExpand && onExpand(expandedNodes, [treeNode.node], expanded, data);
    });
    (0, _defineProperty2.default)(this, "_onSelectionChange", event => {
      const {
        data,
        filter,
        selectionMode
      } = this.props;
      const {
        selectedNodes
      } = this.state;
      let selectedMap = {};
      if (selectionMode === 'single') {
        const key = singleSelect(event, this._data, Object.keys(selectedNodes)[0], this._getId);
        if (key != null) {
          selectedMap = {
            [key]: true
          };
        }
      } else {
        selectedMap = multiSelect(event, this._data, selectedNodes, this._getId).selectedMap;
      }
      if (!this.props.selectedNodes) {
        this.setState({
          selectedNodes: toBoolMap(selectedMap)
        });
      }
      if (filter) {
        const nodes = [];
        const expandedNodes = {
          ...this.state.expandedNodes
        };
        Object.keys(selectedMap).forEach(id => {
          let node = this._byIdMap[id].parent;
          while (node) {
            if (!expandedNodes[node.id]) {
              expandedNodes[node.id] = true;
              nodes.push(node);
            }
            node = this._byIdMap[node.id].parent;
          }
        });
        if (nodes.length) {
          if (!this.props.expandedNodes) {
            this.setState({
              expandedNodes
            });
          }
          const {
            onExpand
          } = this.props;
          onExpand && onExpand(expandedNodes, nodes.map(n => n.node), true, data);
        }
      }
      if (event.pivot && event.index !== -1) {
        this.setState({
          pivot: this._getId(event.index)
        });
      }
      if (event.last != null) {
        this.setState({
          lastClick: this._getId(event.last)
        });
      }
      const {
        onSelectionChange
      } = this.props;
      onSelectionChange && onSelectionChange(this._toObjectMap(selectedMap), this.getOrderedSelectedNodes(selectedMap), data);
    });
    (0, _defineProperty2.default)(this, "_refList", list => {
      this._list = list;
    });
    (0, _defineProperty2.default)(this, "_getIndex", id => id == null ? -1 : findIndex(this._data, treeNode => id === treeNode.id));
    (0, _defineProperty2.default)(this, "_getId", index => this._data[index] ? this._data[index].id : null);
    (0, _defineProperty2.default)(this, "_itemSizeEstimator", (index, cache) => this.props.itemSizeEstimator(this._data[index].node, index, cache));
    (0, _defineProperty2.default)(this, "_itemSizeGetter", index => this.props.itemSizeGetter(this._data[index].node, index));
  }
  componentWillMount() {
    const {
      defaultSelectedNodes,
      selectedNodes,
      defaultExpandedNodes,
      expandedNodes
    } = this.props;
    const selected = toBoolMap(selectedNodes || defaultSelectedNodes || {});
    const expanded = toBoolMap(expandedNodes || defaultExpandedNodes || {});
    this.setState({
      expandedNodes: expanded,
      selectedNodes: selected
    });
  }
  componentWillReceiveProps(nextProps) {
    const {
      filter,
      selectedNodes,
      expandedNodes,
      activeNode,
      isDragging
    } = nextProps;
    const newState = {};
    if (filter !== this.props.filter) {
      newState.filterCollapsedNodes = {};
    }
    if (selectedNodes) {
      newState.selectedNodes = toBoolMap(selectedNodes);
    }
    if (expandedNodes) {
      newState.expandedNodes = toBoolMap(expandedNodes);
    }
    if (activeNode) {
      newState.active = this.props.getId(activeNode);
    }
    if (isDragging) {
      this._flattenTree = false;
    }
    this.setState(newState);
  }
  componentWillUpdate(nextProps, nextState) {
    if (nextState.expandedNodes !== this.state.expandedNodes) {
      Object.keys(nextState.expandedNodes).forEach(id => {
        this._prevExpandedNodes[id] = true;
      });
    }
  }
  componentDidUpdate(prevProps, prevState) {
    const byIdMap = this._byIdMap;
    const {
      expandedNodes,
      filterCollapsedNodes,
      selectedNodes
    } = this.state;
    purge(this._prevExpandedNodes, byIdMap);
    purge(selectedNodes, byIdMap);
    purge(expandedNodes, byIdMap);
    purge(filterCollapsedNodes, byIdMap);
    if (prevState.active !== this.state.active) {
      this._list.scrollAround(this._activeIndex);
    }
  }

  // returns the nodes in the order in which they appear in the tree

  // returns the nodes in the order in which they were selected
  // caveat: id needs to be a non-integer for this to work properly.
  _toFlat(nodes, byIdMap, flatData, depth, focusDepth, startingIndex, parent, isFocusChild) {
    if (depth === void 0) {
      depth = 0;
    }
    if (focusDepth === void 0) {
      focusDepth = 0;
    }
    if (startingIndex === void 0) {
      startingIndex = 0;
    }
    if (parent === void 0) {
      parent = null;
    }
    if (isFocusChild === void 0) {
      isFocusChild = false;
    }
    const {
      getId,
      getChildren,
      getHasChildren,
      isVisible,
      filter,
      isAlwaysExpanded,
      focusNode
    } = this.props;
    const {
      filterCollapsedNodes
    } = this.state;
    const prevExpandedNodes = this._prevExpandedNodes;
    let index = startingIndex;
    for (let i = 0; i < nodes.length; i++) {
      const node = nodes[i];
      const id = getId(node);
      let hasChildren;
      let children;
      if (getHasChildren) {
        hasChildren = getHasChildren(node, depth, focusDepth);
      } else {
        children = getChildren(node, depth, focusDepth);
        hasChildren = !!(children && children.length);
      }
      const alwaysExpanded = isAlwaysExpanded(node, depth, i, nodes.length, focusDepth);
      const treeNode = {
        relativeIndex: i,
        node,
        id,
        depth,
        focusDepth,
        index,
        parent,
        hasChildren,
        visible: true,
        alwaysExpanded
      };
      index += 1;
      byIdMap[id] = treeNode;
      if (filter) {
        const visible = isVisible(filter, node);
        treeNode.visible = isVisible(filter, node);
        if (hasChildren) {
          children = children || getChildren(node, depth, focusDepth) || [];
          const flatChildren = [];
          this._toFlat(children, byIdMap, flatChildren, depth + 1, depth + 1, index, treeNode);
          index += flatChildren.length;
          const filterCollapsed = filterCollapsedNodes[id];
          if (flatChildren.length || visible) {
            flatData.push(treeNode);
          }
          if (flatChildren.length && !filterCollapsed) {
            flatData.push(...flatChildren);
          }
        } else if (visible) {
          flatData.push(treeNode);
        }
      } else {
        const inFocus = !focusNode || focusNode === node || isFocusChild;
        if (flatData && inFocus) {
          flatData.push(treeNode);
        }
        if (hasChildren) {
          const expanded = this._isExpandedById(id) || alwaysExpanded;
          const prevExpanded = prevExpandedNodes[id];
          if (expanded || prevExpanded) {
            children = children || getChildren(node, depth, focusDepth) || [];
            // If we were previously expanded we need to go down this path in order to generate the byIdMap
            // to fully purge data that is no longer accessible.
            // `null` is passed in for `flatData` so that we do not actually add nodes to your flat data.
            const length = flatData ? flatData.length : 0;
            this._toFlat(children, byIdMap, expanded ? flatData : null, depth + 1, focusDepth + (inFocus ? 1 : 0), index, treeNode, inFocus);
            index += flatData ? flatData.length - length : 0;
          }
        }
      }
    }
  }
  _toObjectMap(boolMap) {
    return Object.keys(boolMap).reduce((map, id) => {
      if (boolMap[id] && this._byIdMap[id]) {
        map[id] = this._byIdMap[id].node;
      }
      return map;
    }, {});
  }
  scrollToId(id) {
    const index = this._getIndex(id);
    this._list.scrollTo(index);
  }
  render() {
    const {
      onMenu,
      data,
      getRootNodes,
      className,
      style,
      filter,
      emptyFilterState,
      itemSizeGetter,
      itemSizeEstimator,
      maxHeight,
      allowReorder,
      ...others
    } = this.props;

    // Try reduce the number calls to _toFlat() https://jsw.ibm.com/browse/MUI-1489
    if (allowReorder || this._flattenTree) {
      this._data = [];
      this._byIdMap = {};
      this._toFlat(getRootNodes(data), this._byIdMap, this._data);
    }
    this._flattenTree = true;
    this._activeIndex = this._getIndex(this.state.active);
    this._pivotIndex = this._getIndex(this.state.pivot);
    this._lastClickIndex = this._getIndex(this.state.lastClick);
    const listPassthroughProps = getInheritedProps(others, _list.default);
    if (emptyFilterState && filter && this._data.length === 0) {
      return emptyFilterState;
    }
    return /*#__PURE__*/_react.default.createElement(_list.default, (0, _extends2.default)({
      virtualized: true,
      "data-tid": "ba-tree__list"
    }, sanitize(others, Tree), listPassthroughProps, {
      ref: this._refList,
      activeIndex: this._activeIndex,
      pivotIndex: this._pivotIndex,
      lastClickIndex: this._lastClickIndex,
      length: this._data.length,
      onExpand: this._onExpand,
      getParentIndex: this._getParentIndex,
      role: "tree",
      itemRenderer: this._itemRenderer,
      isExpanded: this._isExpandedByIndex,
      onMenu: onMenu && this._onMenu,
      onSelectionChange: this._onSelectionChange,
      isSelected: this._isSelected,
      onActiveChange: this._onActiveChange,
      getKey: this._getId,
      getItemId: this._getId,
      hierarchical: true,
      className: className,
      style: {
        maxHeight,
        ...style
      },
      itemSizeEstimator: itemSizeEstimator && this._itemSizeEstimator,
      itemSizeGetter: itemSizeGetter && this._itemSizeGetter,
      selectionMark: true
    }));
  }
}
exports["default"] = Tree;
(0, _defineProperty2.default)(Tree, "propTypes", {
  ...sanitize(_list.default.propTypes, null, 'length'),
  onActiveChange: _propTypes.default.func,
  getChildren: _propTypes.default.func.isRequired,
  getId: _propTypes.default.func.isRequired,
  getRootNodes: _propTypes.default.func,
  getHasChildren: _propTypes.default.func,
  onExpand: _propTypes.default.func,
  isVisible: _propTypes.default.func,
  isAlwaysExpanded: _propTypes.default.func,
  onSelectionChange: _propTypes.default.func,
  onMenu: _propTypes.default.func,
  filter: _propTypes.default.string,
  data: _propTypes.default.any.isRequired,
  selectedNodes: _propTypes.default.object,
  defaultSelectedNodes: _propTypes.default.object,
  expandedNodes: _propTypes.default.object,
  defaultExpandedNodes: _propTypes.default.object,
  selectionMode: _propTypes.default.oneOf(['none', 'disabled', 'single', 'multi']),
  activeNode: _propTypes.default.any,
  className: _propTypes.default.string,
  style: _propTypes.default.object,
  emptyFilterState: _propTypes.default.node,
  expandedByDefault: _propTypes.default.bool,
  allowReorder: _propTypes.default.bool,
  isDragging: _propTypes.default.bool,
  focusNode: _propTypes.default.object,
  itemSizeGetter: _propTypes.default.func,
  itemSizeEstimator: _propTypes.default.func,
  /** Specifies the maximum height of the tree */
  maxHeight: _propTypes.default.number
});
(0, _defineProperty2.default)(Tree, "defaultProps", {
  getRootNodes: nodes => Array.isArray(nodes) ? nodes : [nodes],
  getChildren: node => node.children,
  getId: node => node.id,
  isAlwaysExpanded: () => false,
  isVisible: () => true,
  className: '',
  style: {}
});

/***/ }),

/***/ 33498:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var _interopRequireDefault = __webpack_require__(97880);
exports.__esModule = true;
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(__webpack_require__(38213));
var _defineProperty2 = _interopRequireDefault(__webpack_require__(68779));
var _react = _interopRequireWildcard(__webpack_require__(16689));
var _propTypes = _interopRequireDefault(__webpack_require__(580));
var _ = _interopRequireDefault(__webpack_require__(34032));
var _2 = _interopRequireDefault(__webpack_require__(7796));
var _button = _interopRequireDefault(__webpack_require__(32477));
var _list = __webpack_require__(70309);
var _hspacer = _interopRequireDefault(__webpack_require__(39636));
var _flexlayout = __webpack_require__(77765);
var _utils = __webpack_require__(78815);
var _TreeItem = _interopRequireDefault(__webpack_require__(6962));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019, 2021
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */

const treeItemClassName = _TreeItem.default.treeItemClassName.replace(/"/g, '');
const {
  omit
} = _utils.lodash;
const {
  stopEvent
} = _utils.event;
class TreeItem extends _react.Component {
  constructor() {
    super(...arguments);
    (0, _defineProperty2.default)(this, "_onExpand", e => {
      stopEvent(e);
      const {
        onExpand,
        index,
        expanded
      } = this.props;
      onExpand && onExpand(index, !expanded);
    });
    (0, _defineProperty2.default)(this, "_stopPropagation", e => {
      e.stopPropagation();
    });
    (0, _defineProperty2.default)(this, "_onMenu", (x, y, e) => {
      const {
        onMenu
      } = this.props;
      onMenu && onMenu(x, y, e);
    });
  } // This is needed so that we can expand without changing selection
  render() {
    const {
      icon,
      depth,
      alwaysExpanded,
      hasChildren,
      expanded,
      children,
      onMenu,
      index,
      expandTitle,
      pathToRoot,
      isFocusNode,
      ...other
    } = this.props;
    let indent = icon ? 1 : 0;
    if (alwaysExpanded) {
      indent += 2;
    } else if (!hasChildren) {
      indent += 4;
    }
    if (depth != null) {
      indent += depth * 2;
    }
    const passThroughProps = omit(other, 'visible', 'node', 'getSelectedNodes', 'data', 'dragging', 'loading', 'onExpand', 'pathToRoot');
    return /*#__PURE__*/_react.default.createElement(_list.ListItem, (0, _extends2.default)({}, passThroughProps, {
      index: index,
      onMenu: onMenu && this._onMenu,
      className: `${treeItemClassName}`,
      role: "treeitem",
      "aria-expanded": hasChildren ? expanded : null,
      "data-tid": `treeItem${pathToRoot}`
    }), icon, indent > 0 ? /*#__PURE__*/_react.default.createElement(_hspacer.default, {
      size: indent
    }) : null, hasChildren && !alwaysExpanded || isFocusNode ? /*#__PURE__*/_react.default.createElement(_flexlayout.FlexItem, null, /*#__PURE__*/_react.default.createElement(_button.default, {
      hasIconOnly: true,
      kind: "ghost",
      size: "small",
      iconDescription: expandTitle // hidden via css
      ,
      "aria-label": expandTitle,
      onMouseDown: this._stopPropagation,
      onTouchEnd: this._stopPropagation,
      onDoubleClick: this._stopPropagation,
      onClick: this._onExpand,
      renderIcon: expanded ? _2.default : _.default,
      "data-tid": "expandTreeItemClickable"
    })) : null, /*#__PURE__*/_react.default.createElement(_flexlayout.FlexItem, {
      grow: true,
      className: `${treeItemClassName}__child-item`
    }, children));
  }
}
exports["default"] = TreeItem;
(0, _defineProperty2.default)(TreeItem, "propTypes", {
  depth: _propTypes.default.number.isRequired,
  length: _propTypes.default.number.isRequired,
  index: _propTypes.default.number.isRequired,
  icon: _propTypes.default.any,
  selected: _propTypes.default.bool,
  active: _propTypes.default.bool,
  children: _propTypes.default.node.isRequired,
  onMenu: _propTypes.default.func,
  alwaysExpanded: _propTypes.default.bool,
  expanded: _propTypes.default.bool,
  onExpand: _propTypes.default.func,
  hasChildren: _propTypes.default.bool,
  expandTitle: _propTypes.default.string,
  pathToRoot: _propTypes.default.string,
  ellipsisTitle: _propTypes.default.string,
  isFocusNode: _propTypes.default.bool
});
(0, _defineProperty2.default)(TreeItem, "defaultProps", {
  depth: 0
});

/***/ }),

/***/ 36495:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var _interopRequireDefault = __webpack_require__(97880);
exports.__esModule = true;
var _Tree = _interopRequireDefault(__webpack_require__(63815));
exports["default"] = _Tree.default;
exports.Tree = _Tree.default;
var _treeDnD = _interopRequireWildcard(__webpack_require__(40336));
exports.treeDnD = _treeDnD.default;
exports.treeItemDnD = _treeDnD.treeItemDnD;
var _TreeItem = _interopRequireDefault(__webpack_require__(33498));
exports.TreeItem = _TreeItem.default;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }

/***/ }),

/***/ 40336:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var _interopRequireDefault = __webpack_require__(97880);
exports.__esModule = true;
exports["default"] = _default;
exports.treeItemDnD = void 0;
var _extends2 = _interopRequireDefault(__webpack_require__(38213));
var _defineProperty2 = _interopRequireDefault(__webpack_require__(68779));
var _react = _interopRequireWildcard(__webpack_require__(16689));
var _propTypes = _interopRequireDefault(__webpack_require__(580));
var _reactDom = _interopRequireDefault(__webpack_require__(66405));
var _reactDnd = __webpack_require__(47964);
var _draglayer = _interopRequireDefault(__webpack_require__(84803));
var _itemdnd = _interopRequireWildcard(__webpack_require__(40772));
var _utils = __webpack_require__(78815);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */

const treeItemDnD = function (TreeItem, itemType) {
  if (itemType === void 0) {
    itemType = _itemdnd.ITEM_TYPE;
  }
  const options = typeof itemType === 'string' ? {
    dragItemType: itemType,
    dropItemType: itemType
  } : itemType;
  return (0, _itemdnd.default)(TreeItem, options);
};
exports.treeItemDnD = treeItemDnD;
const {
  omit
} = _utils.lodash;
const dropTargetMethods = {
  canDrop(props, monitor) {
    if (props.canDrop && (monitor.isOver({
      shallow: true
    }) || props.canFallThrough && props.canFallThrough())) {
      return props.canDrop({
        data: props.data
      }, monitor.getItem(), monitor);
    }
    return false;
  },
  hover() {},
  drop(props, monitor) {
    if (props.onDrop && !monitor.didDrop()) {
      props.onDrop({
        data: props.data
      }, monitor.getItem(), monitor);
    }
  }
};
function _default(Tree, itemType, TreeDragLayer) {
  var _dec, _class, _class2;
  if (itemType === void 0) {
    itemType = _itemdnd.ITEM_TYPE;
  }
  if (TreeDragLayer === void 0) {
    TreeDragLayer = _draglayer.default;
  }
  const ScrollableTree = (0, _itemdnd.scrollableDnD)(Tree);
  let TreeDnD = (_dec = (0, _reactDnd.DropTarget)(itemType, dropTargetMethods, (connect, monitor) => ({
    connectDropTarget: connect.dropTarget(),
    isActive: () => monitor.isOver() && monitor.canDrop(),
    getDragPosition: () => monitor.getClientOffset()
  })), _dec(_class = (_class2 = class TreeDnD extends _react.Component {
    constructor() {
      super(...arguments);
      (0, _defineProperty2.default)(this, "state", {
        draggingNodes: []
      });
      (0, _defineProperty2.default)(this, "_connectToDnD", ref => {
        this._node = _reactDom.default.findDOMNode(ref);
        this.props.connectDropTarget(this._node);
        this._tree = ref;
        const {
          treeDnDForwardRef
        } = this.props;
        treeDnDForwardRef && treeDnDForwardRef(ref);
      });
      (0, _defineProperty2.default)(this, "_dragLayerRenderer", _ref => {
        let {
          itemProps,
          currentOffset,
          droppable
        } = _ref;
        return /*#__PURE__*/_react.default.createElement(TreeDragLayer, {
          currentOffset: currentOffset,
          droppable: droppable
        }, this.props.dragLayerRenderer(itemProps, droppable));
      });
      (0, _defineProperty2.default)(this, "_itemRenderer", (node, props) => {
        const {
          itemRenderer,
          canDrop,
          onDrop,
          onItemHover
        } = this.props;
        const {
          draggingNodes
        } = this.state;
        const itemDragging = draggingNodes.indexOf(node) >= 0;
        const treeProps = {
          ...props,
          dragging: itemDragging,
          canDrop,
          onDrop,
          canDragNode: this._canDragNode,
          getDropProps: this._getDropProps,
          onBeginDrag: this._onBeginDrag,
          onEndDrag: this._onEndDrag,
          onHover: onItemHover
        };
        return itemRenderer(node, treeProps);
      });
      (0, _defineProperty2.default)(this, "_canDragNode", itemProps => {
        const {
          canDragNode
        } = this.props;
        const {
          node
        } = itemProps;
        const selected = this._tree.getSelectedNodes();
        return selected.indexOf(node) !== -1 && (!canDragNode || canDragNode(node));
      });
      (0, _defineProperty2.default)(this, "_onBeginDrag", itemProps => {
        const {
          data
        } = this.props;
        const {
          node
        } = itemProps;
        const selected = this._tree.getSelectedNodes();
        this.setState({
          draggingNodes: selected
        });
        const payload = {
          node,
          items: selected,
          dragLayerRenderer: this._dragLayerRenderer,
          data
        };
        let newPayload;
        if (this.props.onBeginDrag) {
          newPayload = this.props.onBeginDrag(payload);
        }
        return newPayload == null ? payload : newPayload;
      });
      (0, _defineProperty2.default)(this, "_onEndDrag", () => {
        setTimeout(() => {
          this.setState({
            draggingNodes: []
          });
          this.props.onEndDrag && this.props.onEndDrag();
        }, 0);
      });
    }
    _getDropProps(_ref2, droppedY) {
      let {
        node,
        data,
        expanded,
        isAlwaysExpanded
      } = _ref2;
      return {
        item: node,
        data,
        [typeof droppedY === 'boolean' ? 'droppedBelow' : 'droppedYPercent']: droppedY,
        expanded: expanded || isAlwaysExpanded
      };
    }

    // setTimeout 0 is required here to ensure that drag end state gets set after click events are fired

    render() {
      const {
        draggingNodes
      } = this.state;
      const {
        selectionMode,
        activeClassName,
        isActive,
        ...other
      } = this.props;
      const passThroughProps = omit(other, 'className', 'onDrop', 'canDrop', 'dragLayerRenderer', 'theme', 'connectDropTarget', 'onBeginDrag', 'canDragNode', 'onEndDrag', 'canFallThrough', 'onItemHover', 'getDragPosition', 'treeDnDForwardRef', 'onHoverDropZone');
      let {
        className
      } = this.props;
      if (activeClassName && isActive()) {
        var _this$props$onHoverDr, _this$props;
        className = className ? `${className} ${activeClassName}` : activeClassName;
        (_this$props$onHoverDr = (_this$props = this.props).onHoverDropZone) == null ? void 0 : _this$props$onHoverDr.call(_this$props);
      }
      return /*#__PURE__*/_react.default.createElement(ScrollableTree, (0, _extends2.default)({
        fullHeight: true
      }, passThroughProps, {
        className: className,
        itemRenderer: this._itemRenderer,
        selectionMode: draggingNodes.length && selectionMode !== 'none' ? 'disabled' : selectionMode,
        isDragging: draggingNodes.length,
        ref: this._connectToDnD
      }));
    }
  }, (0, _defineProperty2.default)(_class2, "propTypes", {
    data: _propTypes.default.any.isRequired,
    dragLayerRenderer: _propTypes.default.func,
    canDrop: _propTypes.default.func,
    isActive: _propTypes.default.func,
    getDragPosition: _propTypes.default.func,
    onDrop: _propTypes.default.func,
    itemRenderer: _propTypes.default.func.isRequired,
    connectDropTarget: _propTypes.default.func.isRequired,
    theme: _propTypes.default.string,
    selectionMode: _propTypes.default.string,
    activeClassName: _propTypes.default.string,
    className: _propTypes.default.string,
    onEndDrag: _propTypes.default.func,
    onBeginDrag: _propTypes.default.func,
    canDragNode: _propTypes.default.func,
    onItemHover: _propTypes.default.func,
    canFallThrough: _propTypes.default.func,
    treeDnDForwardRef: _propTypes.default.func,
    onHoverDropZone: _propTypes.default.func
  }), (0, _defineProperty2.default)(_class2, "defaultProps", {
    canFallThrough: () => false
  }), _class2)) || _class);
  return _react.default.forwardRef((props, ref) => /*#__PURE__*/_react.default.createElement(TreeDnD, (0, _extends2.default)({}, props, {
    treeDnDForwardRef: ref
  })));
}

/***/ }),

/***/ 8661:
/***/ ((module, exports, __webpack_require__) => {

exports = module.exports = __webpack_require__(98060)(false);
// imports


// module
exports.push([module.id, ".ba-common-treeItem__button{position:relative}.ba-common-treeItem .ba-common-listItem-with-right-icon .ba-common-button.is-small .ba-common-svgIcon.is-small.is-pad{padding-left:16px;padding-right:16px}.ba-common-treeItem__child-item{padding:0}[dir=ltr].ba-common-treeItem__child-item{padding-right:8px}[dir=rtl].ba-common-treeItem__child-item{padding-right:0;padding-left:8px}[dir=ltr] .ba-common-treeItem__child-item,.ba-common-treeItem__child-item{padding-right:8px}[dir=rtl] .ba-common-treeItem__child-item{padding-right:0;padding-left:8px}.ba-common-treeItem__child-item .ba-common-svgIcon.is-small{min-width:16px}.ba-common-treeItem button[data-tid=expandTreeItemClickable]{border-color:transparent !important;color:inherit;outline:none !important}.ba-common-treeItem button[data-tid=expandTreeItemClickable] span,.ba-common-treeItem button[data-tid=expandTreeItemClickable] div{display:none !important}.ba-common-treeItem button[data-tid=expandTreeItemClickable]::before{display:none !important}.mobile .ba-common-treeItem__button.is-tiny{width:18px;height:18px}.ba-common-treeItem .ba-common-svgIcon{transition-duration:0s}", ""]);

// exports
exports.locals = {
	"treeItemClassName": "\"ba-common-treeItem\""
};

/***/ }),

/***/ 6962:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93379);
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7795);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90569);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3565);
/* harmony import */ var _node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19216);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(44589);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_TreeItem_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8661);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_TreeItem_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_TreeItem_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony reexport (unknown) */ var __WEBPACK_REEXPORT_OBJECT__ = {};
/* harmony reexport (unknown) */ for(const __WEBPACK_IMPORT_KEY__ in _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_TreeItem_scss__WEBPACK_IMPORTED_MODULE_6__) if(__WEBPACK_IMPORT_KEY__ !== "default") __WEBPACK_REEXPORT_OBJECT__[__WEBPACK_IMPORT_KEY__] = () => _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_TreeItem_scss__WEBPACK_IMPORTED_MODULE_6__[__WEBPACK_IMPORT_KEY__]
/* harmony reexport (unknown) */ __webpack_require__.d(__webpack_exports__, __WEBPACK_REEXPORT_OBJECT__);

      
      
      
      
      
      
      
      
      

var options = {};

options.styleTagTransform = (_node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5___default());
options.setAttributes = (_node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3___default());

      options.insert = _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2___default().bind(null, "head");
    
options.domAPI = (_node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1___default());
options.insertStyleElement = (_node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4___default());

var update = _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default()((_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_TreeItem_scss__WEBPACK_IMPORTED_MODULE_6___default()), options);




       /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_TreeItem_scss__WEBPACK_IMPORTED_MODULE_6___default()) && (_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_TreeItem_scss__WEBPACK_IMPORTED_MODULE_6___default().locals) ? (_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_TreeItem_scss__WEBPACK_IMPORTED_MODULE_6___default().locals) : undefined);


/***/ }),

/***/ 93379:
/***/ ((module) => {

"use strict";


var stylesInDOM = [];
function getIndexByIdentifier(identifier) {
  var result = -1;
  for (var i = 0; i < stylesInDOM.length; i++) {
    if (stylesInDOM[i].identifier === identifier) {
      result = i;
      break;
    }
  }
  return result;
}
function modulesToDom(list, options) {
  var idCountMap = {};
  var identifiers = [];
  for (var i = 0; i < list.length; i++) {
    var item = list[i];
    var id = options.base ? item[0] + options.base : item[0];
    var count = idCountMap[id] || 0;
    var identifier = "".concat(id, " ").concat(count);
    idCountMap[id] = count + 1;
    var indexByIdentifier = getIndexByIdentifier(identifier);
    var obj = {
      css: item[1],
      media: item[2],
      sourceMap: item[3],
      supports: item[4],
      layer: item[5]
    };
    if (indexByIdentifier !== -1) {
      stylesInDOM[indexByIdentifier].references++;
      stylesInDOM[indexByIdentifier].updater(obj);
    } else {
      var updater = addElementStyle(obj, options);
      options.byIndex = i;
      stylesInDOM.splice(i, 0, {
        identifier: identifier,
        updater: updater,
        references: 1
      });
    }
    identifiers.push(identifier);
  }
  return identifiers;
}
function addElementStyle(obj, options) {
  var api = options.domAPI(options);
  api.update(obj);
  var updater = function updater(newObj) {
    if (newObj) {
      if (newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap && newObj.supports === obj.supports && newObj.layer === obj.layer) {
        return;
      }
      api.update(obj = newObj);
    } else {
      api.remove();
    }
  };
  return updater;
}
module.exports = function (list, options) {
  options = options || {};
  list = list || [];
  var lastIdentifiers = modulesToDom(list, options);
  return function update(newList) {
    newList = newList || [];
    for (var i = 0; i < lastIdentifiers.length; i++) {
      var identifier = lastIdentifiers[i];
      var index = getIndexByIdentifier(identifier);
      stylesInDOM[index].references--;
    }
    var newLastIdentifiers = modulesToDom(newList, options);
    for (var _i = 0; _i < lastIdentifiers.length; _i++) {
      var _identifier = lastIdentifiers[_i];
      var _index = getIndexByIdentifier(_identifier);
      if (stylesInDOM[_index].references === 0) {
        stylesInDOM[_index].updater();
        stylesInDOM.splice(_index, 1);
      }
    }
    lastIdentifiers = newLastIdentifiers;
  };
};

/***/ }),

/***/ 90569:
/***/ ((module) => {

"use strict";


var memo = {};

/* istanbul ignore next  */
function getTarget(target) {
  if (typeof memo[target] === "undefined") {
    var styleTarget = document.querySelector(target);

    // Special case to return head of iframe instead of iframe itself
    if (window.HTMLIFrameElement && styleTarget instanceof window.HTMLIFrameElement) {
      try {
        // This will throw an exception if access to iframe is blocked
        // due to cross-origin restrictions
        styleTarget = styleTarget.contentDocument.head;
      } catch (e) {
        // istanbul ignore next
        styleTarget = null;
      }
    }
    memo[target] = styleTarget;
  }
  return memo[target];
}

/* istanbul ignore next  */
function insertBySelector(insert, style) {
  var target = getTarget(insert);
  if (!target) {
    throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
  }
  target.appendChild(style);
}
module.exports = insertBySelector;

/***/ }),

/***/ 19216:
/***/ ((module) => {

"use strict";


/* istanbul ignore next  */
function insertStyleElement(options) {
  var element = document.createElement("style");
  options.setAttributes(element, options.attributes);
  options.insert(element, options.options);
  return element;
}
module.exports = insertStyleElement;

/***/ }),

/***/ 3565:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


/* istanbul ignore next  */
function setAttributesWithoutAttributes(styleElement) {
  var nonce =  true ? __webpack_require__.nc : 0;
  if (nonce) {
    styleElement.setAttribute("nonce", nonce);
  }
}
module.exports = setAttributesWithoutAttributes;

/***/ }),

/***/ 7795:
/***/ ((module) => {

"use strict";


/* istanbul ignore next  */
function apply(styleElement, options, obj) {
  var css = "";
  if (obj.supports) {
    css += "@supports (".concat(obj.supports, ") {");
  }
  if (obj.media) {
    css += "@media ".concat(obj.media, " {");
  }
  var needLayer = typeof obj.layer !== "undefined";
  if (needLayer) {
    css += "@layer".concat(obj.layer.length > 0 ? " ".concat(obj.layer) : "", " {");
  }
  css += obj.css;
  if (needLayer) {
    css += "}";
  }
  if (obj.media) {
    css += "}";
  }
  if (obj.supports) {
    css += "}";
  }
  var sourceMap = obj.sourceMap;
  if (sourceMap && typeof btoa !== "undefined") {
    css += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))), " */");
  }

  // For old IE
  /* istanbul ignore if  */
  options.styleTagTransform(css, styleElement, options.options);
}
function removeStyleElement(styleElement) {
  // istanbul ignore if
  if (styleElement.parentNode === null) {
    return false;
  }
  styleElement.parentNode.removeChild(styleElement);
}

/* istanbul ignore next  */
function domAPI(options) {
  if (typeof document === "undefined") {
    return {
      update: function update() {},
      remove: function remove() {}
    };
  }
  var styleElement = options.insertStyleElement(options);
  return {
    update: function update(obj) {
      apply(styleElement, options, obj);
    },
    remove: function remove() {
      removeStyleElement(styleElement);
    }
  };
}
module.exports = domAPI;

/***/ }),

/***/ 44589:
/***/ ((module) => {

"use strict";


/* istanbul ignore next  */
function styleTagTransform(css, styleElement) {
  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css;
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild);
    }
    styleElement.appendChild(document.createTextNode(css));
  }
}
module.exports = styleTagTransform;

/***/ }),

/***/ 68779:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 38213:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/extends");

/***/ }),

/***/ 97880:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/interopRequireDefault");

/***/ }),

/***/ 7796:
/***/ ((module) => {

"use strict";
module.exports = require("@carbon/icons-react/lib/caret--down/16");

/***/ }),

/***/ 34032:
/***/ ((module) => {

"use strict";
module.exports = require("@carbon/icons-react/lib/caret--right/16");

/***/ }),

/***/ 98060:
/***/ ((module) => {

"use strict";
module.exports = require("css-loader/lib/css-base");

/***/ }),

/***/ 580:
/***/ ((module) => {

"use strict";
module.exports = require("prop-types");

/***/ }),

/***/ 16689:
/***/ ((module) => {

"use strict";
module.exports = require("react");

/***/ }),

/***/ 47964:
/***/ ((module) => {

"use strict";
module.exports = require("react-dnd");

/***/ }),

/***/ 66405:
/***/ ((module) => {

"use strict";
module.exports = require("react-dom");

/***/ }),

/***/ 32477:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__32477__;

/***/ }),

/***/ 84803:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__84803__;

/***/ }),

/***/ 77765:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__77765__;

/***/ }),

/***/ 39636:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__39636__;

/***/ }),

/***/ 40772:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__40772__;

/***/ }),

/***/ 70309:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__70309__;

/***/ }),

/***/ 78815:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__78815__;

/***/ })

},
/******/ __webpack_require__ => { // webpackRuntimeModules
/******/ var __webpack_exec__ = (moduleId) => (__webpack_require__(__webpack_require__.s = moduleId))
/******/ var __webpack_exports__ = (__webpack_exec__(36495));
/******/ return __webpack_exports__;
/******/ }
]);
});